export default __webpack_public_path__ + "static/media/living6.5bcf0cb1.jpg";